import React from 'react'
import { makeStyles } from '@material-ui/styles'
import { mutualTheme } from '~/utils/theme'
import { Box, Typography } from '@material-ui/core'
import { DocumentAnalysisStatus } from '@mutual-services/account-documents-types'
import { translateDocumentPendencyStatus, getDocumentPendencyStatusColor } from '~/utils/documents'
import { useIsMobileScreen } from '~/hooks'

export type DocumentStatusBadgeProps = {
  status: DocumentAnalysisStatus
}

const useStyles = makeStyles({
  circle: (props: DocumentStatusBadgeProps) => ({
    borderRadius: 50,
    width: mutualTheme.spacing(1),
    height: mutualTheme.spacing(1),
    backgroundColor: getDocumentPendencyStatusColor(props.status)
  })
})

export const DocumentStatusBadge: React.FC<DocumentStatusBadgeProps> = (props) => {
  const { status } = props
  const classes = useStyles(props)
  const isMobile = useIsMobileScreen()

  return (
    <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
      <Box className={classes.circle} />
      <Typography color={getDocumentPendencyStatusColor(status)} variant={isMobile ? 'airbnbBody2' : 'airbnbBody1'} sx={{ marginLeft: 1, fontWeight: 500 }}>
        {translateDocumentPendencyStatus(status)}
      </Typography>
    </Box>
  )
}
